'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "Which marketplaces do you help sellers grow on?",
    answer: "We support sellers on top Indian marketplaces like Amazon, Flipkart, Meesho, Myntra, and AJIO. Our team ensures your products are well-optimized and visible to the right customers across platforms."
  },
  {
    question: "I'm new to online selling — can you handle everything for me?",
    answer: "Absolutely. From account setup to product listing, cataloging, and running ad campaigns — we manage the full process so you can focus on your business while we handle the technical side."
  },
  {
    question: "How soon will I start seeing better performance?",
    answer: "Most clients notice improvements in traffic and sales within a few weeks, especially after listing optimization and ad campaigns begin. Long-term growth is driven by strategy, consistency, and analytics."
  },
  {
    question: "Do I need a separate strategy for each platform?",
    answer: "Yes — every marketplace has its own algorithm, audience behavior, and policies. We tailor strategies specifically for each platform to maximize your product performance and ROI."
  },
  {
    question: "What’s the first step if I want to work with you?",
    answer: "Just reach out through our website or give us a call. We’ll schedule a free consultation to understand your business goals and suggest a plan that fits your brand, budget, and sales ambitions."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className='col text-center' data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level="3"
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                   <span
                      className={`transition-colors duration-200 cursor-pointer 
                        hover:text-purple-600 
                        ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
                    >{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div
                    className="accordion__panel faq-ans"
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
